import Controller, { inject as controller } from '@ember/controller';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { Changeset } from 'ember-changeset';
import { BufferedChangeset, ValidatorAction } from 'ember-changeset/types';
import type ApplicationController from './application';
import type ModelService from '../services/model';
import type SensorService from '../services/sensor';
import SchematicFigure from '../components/figures/schematic';

export default class PhotodiodeController extends Controller {
  @service('model') declare modelService: ModelService;
  @service('sensor') declare sensorService: SensorService;
  @controller('application')
  declare applicationController: ApplicationController;
  @tracked figureTab = 'schematic';
  @tracked changesetObj: BufferedChangeset = Changeset({}); // Very temporary value - see init()
  @tracked isCriticalError = false;
  updateEnabledTabs?: (tab: string, isError: boolean) => void;
  figures: Record<string, unknown> = {
    schematic: SchematicFigure,
  };

  systemDialogFunc?: (status: string, message: string, msgparams?: Record<string, unknown>) => void;
  openNotification?: (title: string, message: string, msgparams?: Record<string, unknown>) => void;

  // eslint-disable-next-line ember/classic-decorator-hooks
  init(): void {
    super.init();
    this.changesetObj = Changeset(this.modelService.state, this.modelService.validate as ValidatorAction);
    this.applicationController.addSaveValidator(this.validateSafeToSave);
  }

  @action insertingPhotodiode(): void {
    if (!this.modelService.limits) {
      if (this.sensorService.sensors) {
        if (this.systemDialogFunc) this.systemDialogFunc('ON', 'application-busy');
        this.sensorService.sensors.then(async (sensors) => {
          if (this.systemDialogFunc) this.systemDialogFunc('OFF', '');
          if (sensors === null) {
            this.isCriticalError = true;
            if (this.openNotification)
              this.openNotification('dialogs.system.title', 'dialogs.system.error-config-data');
            if (this.updateEnabledTabs) this.updateEnabledTabs('photodiode', this.isCriticalError);
          }
        });
      }
    }
  }

  @action validateSafeToSave(): boolean {
    return !this.changesetObj.isInvalid;
  }

  get figureClass(): unknown {
    return this.figures[this.figureTab];
  }

  setupDialogFunctions(parentController: ApplicationController): void {
    this.systemDialogFunc = parentController.systemDialogFunc;
    this.openNotification = parentController.openNotification;
  }
}
